export const environment = {
  production: false,
  appConfigurationApiBaseUrl: 'https://dplistener-azfunction-dev-cvx.azurewebsites.net/',

  // CAL/Azure AD settings
  envName: 'dev', // This should match your CAL config file, e.g., cal.dev.json
  clientId: '4870c084-1c86-4ee3-a75c-e13818b8f806',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  redirectUri: 'https://app-configuration-manager-dev-cvx.azurewebsites.net/',
  audience: 'https://wellpl-test.azure.chevron.com',
  oidcScopes: [
    'https://wellpl-test.azure.chevron.com/user_impersonation',
    'openid',
    'profile',
    'offline_access'
  ]
};